// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { miniCartLineStyles } from "@steiner/App/Components/MiniCart/MiniCartLineCard";
import AlertWarning from "@steiner/XDL/Icons/AlertWarning";
import MenuClose from "@steiner/XDL/Icons/MenuClose";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedLineDescriptionStyle: TypographyPresentationProps = {
    size: 14,
    lineHeight: "18px",
    weight: fontConfig.weight.semiBold,
    css: css`
        ${ellipsis(2)}
    `,
};

const sharedPriceText: TypographyPresentationProps = {
    size: 12,
    lineHeight: "15px",
};

miniCartLineStyles.cartLine = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding-bottom: 12px;

        &:not(:last-child) {
            margin-bottom: 12px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

miniCartLineStyles.imageWrapper = {
    css: css`
        ${TypographyStyle} {
            max-width: 86px;
            max-height: 86px;
        }
    `,
};

miniCartLineStyles.cartLineImage = {
    linkWrappingImage: {
        css: css`
            flex-shrink: 0;
            width: 86px;
            height: 86px;
        `,
    },
    img: {
        width: "86px",
        height: "86px",
        css: css`
            aspect-ratio: 1 / 1;
        `,
    },
};

miniCartLineStyles.cartLineNonStockImage = {
    width: "86px",
    height: "86px",
    css: css`
        display: flex;
        flex-shrink: 0;
        aspect-ratio: 1;

        img {
            aspect-ratio: 1;
        }
    `,
};

miniCartLineStyles.contentWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        justify-content: space-between;
    `,
};

miniCartLineStyles.lineDescription = {
    productDetailLink: {
        typographyProps: {
            ...sharedLineDescriptionStyle,
        },
    },
    productDetailDescription: {
        ...sharedLineDescriptionStyle,
    },
};

miniCartLineStyles.nonStockDescription = {
    ...sharedLineDescriptionStyle,
};

miniCartLineStyles.removeCartLine = {
    src: MenuClose,
    size: 9,
    color: "common.ui5",
    css: css`
        cursor: pointer;
        &:hover {
            color: ${color("common.ui9")};
            opacity: 0.66;
        }
    `,
};

miniCartLineStyles.qtyAndPriceWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    `,
};

miniCartLineStyles.priceWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
    `,
};

miniCartLineStyles.priceTitle = {
    ...sharedPriceText,
};

miniCartLineStyles.priceValue = {
    ...sharedPriceText,
    weight: fontConfig.weight.semiBold,
    color: "primary",
};

miniCartLineStyles.extPriceTitle = {
    ...sharedPriceText,
};

miniCartLineStyles.extPriceValue = {
    size: 16,
    lineHeight: "22px",
    weight: fontConfig.weight.semiBold,
    color: "primary",
};

miniCartLineStyles.qtyAndWarningIconWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

miniCartLineStyles.alertIcon = {
    src: AlertWarning,
    size: 20,
    color: "warning.main",
};

miniCartLineStyles.priceNotAvailable = {
    size: 12,
    lineHeight: "15px",
};